import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IStandardDocument } from '../../../types/order/documents/shared/interfaces';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export const getStandardDocumentsByOrderId = (orderId: string): Promise<IStandardDocument[] | Error> =>
  APIFactory(baseUrlService.ApiLocation)
    .get(`/documents/v5/${orderId}/documents`)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
